import { Dialog } from 'vant'
//判断设备
const isWeixin = () => {
    var ua = window.navigator.userAgent.toLowerCase();

    if (ua.indexOf("micromessenger") > -1) {
        return true
    } else {
        return false;
    }
}
//判断设备
const isAndroid=()=>{

    var u = navigator.userAgent;

    if(u.indexOf('Android') > -1 || u.indexOf('Adr') > -1){
        return true     //android终端
    }else if(!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)){
        return false    //ios终端
    }
}

//本地存储
const getStorage = (value) => {
    return window.localStorage.getItem(value)
}

const setStorage = (name, value) => {
    window.localStorage.setItem(name, value)
}

const removeStorage = (value) => {
    window.localStorage.removeItem(value);
}


//去登录弹框
const loginDialog = () => {
    Dialog.confirm({
            title: '提示',
            message: '您还未登录，请先登陆~',
            confirmButtonText: '去登录',
            cancelButtonText: '再看看'
        })
        .then(() => {
            //
            console.log(123)
            setTimeout(function() {
                location.href = '/login'
            }, 200)
        })
        .catch(() => {
            return;
        })
}
export default {
    isWeixin,
    isAndroid,
    getStorage,
    setStorage,
    removeStorage,
    loginDialog,
}